import { Link } from 'react-router-dom';
import { useCountUp } from '@/hooks/useScrollReveal';

export default function RetailHero() {
  const { count: orderCount, countRef } = useCountUp(12000, 2000, true);
  const { count: cityCount, countRef: cityRef } = useCountUp(28, 2000, true);

  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-accent-600 via-accent-500 to-brand-700">
      <div className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.3'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-accent-700/60"></div>

      <div className="absolute right-0 top-0 w-1/2 h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-accent-600/30 to-accent-500/80"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20home%20kitchen%20scene%20with%20a%20family%20unpacking%20a%20premium%20frozen%20food%20delivery%20box%20on%20a%20clean%20marble%20counter%2C%20lifestyle%20photography%2C%20soft%20natural%20window%20light%2C%20warm%20amber%20and%20cream%20tones%2C%20aspirational%20yet%20authentic%2C%20editorial%20quality&width=900&height=800&seq=freshhlock-retail-hero&orientation=portrait"
          alt="Family unpacking frozen food delivery"
          className="w-full h-full object-cover opacity-25"
        />
      </div>

      <div className="container-page relative z-10">
        <div className="flex flex-col lg:flex-row items-center min-h-[500px] md:min-h-[560px] py-16 md:py-20">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-400/30 border border-accent-300/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-200"></div>
              <span className="text-xs font-medium text-accent-100 uppercase tracking-widest">
                Freshhlock Retail
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-paper-50 leading-tight mb-6 text-balance">
              Hygienic, Standard-Cut Frozen Food. Delivered Cold, Every Time.
            </h1>
            <p className="text-base md:text-lg text-accent-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Skip the guesswork of fresh markets — order seafood, meat, poultry and vegetables frozen at peak quality, delivered to your doorstep with full cold-chain integrity.
            </p>

            <div className="flex flex-wrap items-center gap-8 justify-center lg:justify-start">
              <div className="text-center">
                <div ref={countRef} className="font-heading text-3xl font-bold text-accent-200 tabular-nums">
                  {orderCount.toLocaleString()}+
                </div>
                <div className="text-xs text-accent-100/70 mt-1">Orders Delivered Monthly</div>
              </div>
              <div className="text-center">
                <div ref={cityRef} className="font-heading text-3xl font-bold text-paper-50 tabular-nums">
                  {cityCount}
                </div>
                <div className="text-xs text-accent-100/70 mt-1">Cities Served</div>
              </div>
            </div>

            <div className="mt-8">
              <Link
                to="/retail"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 hover:bg-background-100 text-accent-700 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Start Shopping
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
          <div className="hidden lg:block w-2/5"></div>
        </div>
      </div>
    </section>
  );
}